<div
  [classList]="containerClassToAplly() + (hasGlobalMessages() ? '-global-message' : '') + (hasGlobalMessages() && ' global-message')">

  <app-notification></app-notification>

  @defer(on timer(0.5s)) {
  @if (!isInBlankComponent()) {
  <app-global-message class="sticky-top"></app-global-message>
  }
  }

  @if (showAppHeader() && !isInBlankComponent()) {
  <app-header class="sticky-top header"></app-header>
  }

  @defer (on timer(0.5s)) {
  @if (!isMobile() && !isInBlankComponent()) {
  <div class="cart-preview"
    [ngClass]="{'cart-preview--height': !hasGlobalMessages(), 'cart-preview--height-global-message': hasGlobalMessages()}"
    [class.open]="showAppCartPreview()">
    <app-side-checkout></app-side-checkout>
  </div>
  }
  }

  @if(showAppCartPreview() && !isInBlankComponent()){
  <div class="backdrop-cart-preview" (click)="showCartPreview.set(false)"></div>
  }

  <div class="main-container" appScrollToTop [class.header-showing]="showAppHeader() && !hasGlobalMessages()"
    [class.header-showing-global-message]="showAppHeader() && hasGlobalMessages()"
    [class.header-showing-hidden-sub-nav]="!shouldShowCategoriesBar() && !hasGlobalMessages()"
    [class.header-showing-hidden-sub-nav-global-message]="!shouldShowCategoriesBar() && hasGlobalMessages()"
    [class.cart-preview-showing]="showAppCartPreview()" [class.mobile-main-container]="showMobileFooter()"
    [class.blur]="showCartPreview() && !isMobile()" [class.hidden-mobile-footer]="!showMobileFooter()">
    <router-outlet />
  </div>

  @if (showMobileFooter() && !isInBlankComponent()) {
  <app-mobile-footer-menu></app-mobile-footer-menu>
  }

  @if (loadingService.isShowGlobalLoading()) {
  <app-loading></app-loading>
  }

</div>